<template>
  <main class="grid content-center w-full h-full bg-black">
    <ClientOnly>
      <VideoPlayer
        v-slot="slotProps"
        :options="options"
        borderless
        @on-play="$emit('on-play', $event)"
        @on-pause="$emit('on-pause', $event)"
      >
        <div v-if="!slotProps.hasStarted" class="video-overlay" @click="slotProps.handlePlayClick()">
          <div class="p-5">
            <p class="overflow-hidden text-base text-white truncate text-ellipsis">{{ title }}</p>
          </div>
          <div class="flex justify-center">
            <PlayButton width="12%" />
          </div>
          <div class="flex justify-center p-5 text-base text-white">powered by <VrifyLogo class="inline-block ml-1" width="100" /></div>
        </div>
      </VideoPlayer>
    </ClientOnly>
  </main>
</template>

<script lang="ts" setup>
import PlayButton from '@/components/icons/Play.svg'
import VrifyLogo from '~/assets/images/vrify-logo.svg'
import type { PlayerOptions } from '@/entities/videoPlayer'
import type { PropType } from 'vue'

definePageMeta({
  layout: 'isolated-page',
})

defineProps({
  options: {
    type: Object as PropType<PlayerOptions>,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
})

defineEmits(['on-play', 'on-pause'])
</script>

<style lang="stylus" scoped>
.video-overlay
  @apply absolute top-0 left-0 flex flex-col cursor-pointer justify-between h-full w-full mx-auto aspect-video overflow-hidden
  background: linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.65) 10%, rgba(0,0,0,0) 45%, rgba(0,0,0,0) 55%, rgba(0,0,0,0.65) 90%, rgba(0,0,0,1) 100%)
  background-position: center center
  background-repeat: no-repeat
  background-size: cover
  object-fit: cover
</style>
